// Check if the current organization has a scoped path.
// Calls https://gitlab.com/gitlab-org/gitlab/-/blob/4202e37329fb343ae674db79593ce04427ebab6b/app/models/organizations/organization.rb#L127
// Used to support automatic swapping of organization scoped routes similar to what we do in
// https://gitlab.com/gitlab-org/gitlab/-/blob/4202e37329fb343ae674db79593ce04427ebab6b/app/helpers/routing/organizations_helper.rb#L92
export const hasOrganizationScopedPaths = () =>
  gon?.current_organization?.has_scoped_paths ?? false;

// The private `namespaceProject` helpers expect separate `namespacePath`
// and `projectPath` arguments. Typically we only have `project.fullPath`
// available on the frontend. This util splits `project.fullPath` into
// separate arguments so they can be passed to the private `namespaceProject` helpers.
export const splitProjectFullPath = (projectFullPath) => {
  if (!projectFullPath) {
    throw new Error('Route missing required keys: projectFullPath');
  }

  if (typeof projectFullPath !== 'string') {
    throw new Error('projectFullPath must be a string');
  }

  const splitProjectFullPath = projectFullPath.split("/");
  const namespacePath = splitProjectFullPath.slice(0, -1).join("/");
  const projectPath = splitProjectFullPath.at(-1);

  return { namespacePath, projectPath };
};
